import { InjectionToken } from '@angular/core';

export const HttpClientBypass = new InjectionToken(
  'http client ovverride bypass'
);
